import React from 'react';
import { Link } from 'react-router-dom';
import { formatShortDate } from '../../../utils/articleUtils';

const ArticlesGrid = ({ filteredArticles }) => {
  return (
    <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {filteredArticles.length === 0 && (
        <div className="col-span-full text-center text-gray-600">
          Nenhum artigo encontrado para este filtro.
        </div>
      )}
      {filteredArticles.map((article) => {
        const dateLabel = formatShortDate(article.publishedAt) || 'Sem data';

        return (
          <Link
            key={article.id}
            to={`/blog/artigos/${article.slug}`}
            className="group block"
            aria-label={`Ler artigo ${article.title}`}
          >
            <article className="bg-white rounded-lg border border-gray-200 shadow-lg site-card overflow-hidden flex flex-col h-full transition-shadow duration-300 group-hover:shadow-xl">
              <div className="p-6 flex-grow">
                <p className="text-sm text-gray-500 mb-2">{article.category}</p>
                <h3 className="text-xl font-semibold text-gray-900">{article.title}</h3>
                <p className="mt-4 text-gray-600">{article.excerpt}</p>
              </div>
              <div className="bg-gray-50 p-4 border-t border-gray-200 site-card-strip flex items-center justify-between text-sm text-gray-500">
                <span>{dateLabel}</span>
                <span>{article.readTime} min</span>
              </div>
            </article>
          </Link>
        );
      })}
    </div>
  );
};

export default ArticlesGrid;
